import { css } from 'styled-components';
import {
  standardColours,
  greyColours,
  brandColours,
  visuallyHidden,
  standardTransition,
  fontSize,
} from '../../styles';

export const labelStyles = () => {
  return css`
    display: block;
    margin-bottom: 14px;
  `;
};

export const commonFormElementStyles = () => {
  return css`
    padding: 10px 12px;
    height: 48px;
    width: 100%;
    background-color: ${standardColours.white};
    border: 1px solid ${greyColours.lightGrey};
  `;
};

export const inputStyles = () => {
  return css`
    ${commonFormElementStyles()};
  `;
};

export const selectWrapStyles = () => {
  return css`
    position: relative;
    display: block;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: calc(50% - 2px);
      right: 15px;
      height: 5px;
      width: 5px;
      border: 2px solid ${brandColours.primary};
      border-top: 0;
      border-left: 0;
      pointer-events: none;
    }

    &:before {
      transform: translateY(-4px) rotate(-135deg);
    }

    &:after {
      transform: translateY(4px) rotate(45deg);
    }
  `;
};

export const selectStyles = () => {
  return css`
    ${commonFormElementStyles()};
    padding-right: 32px;
    appearance: none;
  `;
};

export const textareaStyles = () => {
  return css`
    ${commonFormElementStyles()};
    height: 100px;
    min-height: 50px;
    max-height: 150px;
  `;
};

export const radioInputStyles = () => {
  return css`
    ${visuallyHidden()};

    &:checked + span {
      color: ${({ alt }) =>
        alt ? standardColours.white : brandColours.primary};
      background-color: ${({ alt }) =>
        alt ? brandColours.primary : brandColours.quaternary};
      border-color: ${({ alt }) =>
        alt ? brandColours.primary : brandColours.quaternary};

      &:before {
        border-color: ${({ alt }) =>
          alt ? standardColours.white : brandColours.primary};
      }

      &:after {
        border-color: ${({ alt }) =>
          alt ? standardColours.white : brandColours.primary};
      }
    }
  `;
};

export const radioStyles = () => {
  return css`
    position: relative;
    display: block;
    padding: 12px 20px 12px 40px;
    border: 1px solid
      ${({ alt }) => (alt ? brandColours.primary : greyColours.lightGrey)};
    cursor: pointer;
    transition: ${standardTransition('color')},
      ${standardTransition('background-color')},
      ${standardTransition('border-color')};

    &:before,
    &:after {
      content: '';
      position: absolute;
      transition: ${standardTransition('border-color')};
    }

    &:before {
      top: 12px;
      left: 12px;
      height: 20px;
      width: 20px;
      border: 1px solid
        ${({ alt }) => (alt ? brandColours.primary : greyColours.lightGrey)};
      border-radius: 50%;
    }

    &:after {
      top: 16px;
      left: 19px;
      height: 9px;
      width: 5px;
      border: 1px solid ${standardColours.transparent};
      border-top: none;
      border-left: none;
      transform: rotate(45deg);
    }
  `;
};

export const checkboxStyles = () => {
  return css`
    position: relative;
    display: block;
    padding-left: 30px;
    ${fontSize(14)};
    color: ${greyColours.darkPurplishGrey};

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      border: 1px solid ${greyColours.darkPurplishGrey};
    }

    &:before {
      left: 0;
      height: 20px;
      width: 20px;
      transform: translateY(-50%);
    }

    &:after {
      left: 4px;
      height: 6px;
      width: 12px;
      border-top: 0;
      border-right: 0;
      opacity: 0;
      transform: translateY(calc(-50% - 2px)) rotate(-45deg);
      transition: ${standardTransition('opacity')};
    }
  `;
};

export const errorStyles = () => {
  return css`
    &.error input {
      border: 1px solid red;
    }
    &.error span.error {
      display: block;
      margin-top: 6px;
      color: red;
      text-align: right;
      text-transform: uppercase;
      ${fontSize(12)}
    }
  `;
};

export const selectErrorStyles = () => {
  return css`
    &.error select {
      border-color: red;
    }
    &.error span.error {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: -6px;
      color: red;
      display: block;
      transform: translateY(100%);
      text-align: right;
      text-transform: uppercase;
      ${fontSize(12)}
    }
  `;
};
